import { Grid, GridItem } from '@chakra-ui/react'
import { AlertPanel } from '../components/alerts/AlertPanel'
import { LiveMonitoring } from '../components/live-monitoring/LiveMonitoring'
import { ThreeDViewer } from '../components/three-d-viewer/ThreeDViewer'
import { MultiLayer } from '../components/multi-layer/MultiLayer'

export const Overview = () => {
  return (
    <Grid
      templateColumns="repeat(4, 1fr)"
      templateRows="repeat(2, 1fr)"
      gap={4}
      h="calc(100vh - 32px)"
      p={4}
    >
      <GridItem colSpan={1} rowSpan={1}>
        <AlertPanel />
      </GridItem>
      <GridItem colSpan={2} rowSpan={1}>
        <LiveMonitoring />
      </GridItem>
      <GridItem colSpan={1} rowSpan={2}>
        <MultiLayer />
      </GridItem>
      <GridItem colSpan={3} rowSpan={1}>
        <ThreeDViewer />
      </GridItem>
    </Grid>
  )
}
